import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { apiFetch } from '../../../utils/api'
import { isMainCompanyScope } from './monthlyConfigurationScope.js'

const departments = ref([])
const isLoadingDepartments = ref(false)

function departmentIsActive(row) {
  if (!row || typeof row !== 'object') return false
  const status = row.status
  return status === 1 || status === '1' || status === true
}

export function useMonthlyConfigurationDepartments() {
  const store = useStore()

  const currentUser = computed(() => store.getters.currentUser || store.state.user || {})

  const companyId = computed(() =>
    currentUser.value?.companyId ||
    currentUser.value?.company_id ||
    currentUser.value?.company?.id ||
    null
  )

  const branchId = computed(() =>
    currentUser.value?.branchId ||
    currentUser.value?.branch_id ||
    currentUser.value?.branch?.id ||
    null
  )

  async function loadDepartments(selectedBranchId = null) {
    const scopeId = selectedBranchId != null && String(selectedBranchId).trim() !== ''
      ? String(selectedBranchId).trim()
      : null

    if (!scopeId) {
      isLoadingDepartments.value = false
      departments.value = []
      return
    }

    isLoadingDepartments.value = true
    try {
      const url = isMainCompanyScope(scopeId)
        ? '/departments/monthly-configuration/company'
        : `/departments/monthly-configuration/branch/${encodeURIComponent(scopeId)}`

      const response = await apiFetch(url, { method: 'GET' })
      if (!response.ok) {
        departments.value = []
        return
      }

      const data = await response.json().catch(() => [])
      const rows = Array.isArray(data) ? data : []
      departments.value = rows.filter(departmentIsActive)
    } catch (err) {
      console.error('Error loading departments for monthly configuration:', err)
      departments.value = []
    } finally {
      isLoadingDepartments.value = false
    }
  }

  return {
    departments,
    isLoadingDepartments,
    loadDepartments,
    companyId,
    branchId
  }
}
